import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Nová interná správa")
], -1)
const _hoisted_2 = { class: "flex flex-row gap-2" }
const _hoisted_3 = { class: "flex-1" }
const _hoisted_4 = { class: "flex-1" }
const _hoisted_5 = {
  key: 0,
  class: ""
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "" }
const _hoisted_8 = ["on:afterMessageSend"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "pt-1 pb-1 flex flex-wrap gap-1" }
const _hoisted_11 = { class: "w-10" }
const _hoisted_12 = { class: "text-700 text-base font-medium mb-1" }
const _hoisted_13 = { class: "text-500 text-sm font-medium overflow-hidden text-overflow-ellipsis" }
const _hoisted_14 = { class: "text-400 text-xs" }
const _hoisted_15 = { class: "w-2 align-items-center flex" }
const _hoisted_16 = { class: "mt-2 flex justify-content-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimevueTextarea = _resolveComponent("PrimevueTextarea")!
  const _component_PrimevueSelect = _resolveComponent("PrimevueSelect")!
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_PrimevuePanel = _resolveComponent("PrimevuePanel")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_PrimevuePanel, { class: "border-solid border-1 surface-border" }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    icons: _withCtx(() => []),
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => ($options.sendMessage && $options.sendMessage(...args)), ["prevent"])),
        name: "messageForm"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_PrimevueTextarea, {
              modelValue: $data.text,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.text) = $event)),
              class: "w-full",
              rows: 4
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_FileUpload, {
              name: "files[]",
              url: "",
              multiple: true,
              maxFileSize: 10000000,
              customUpload: true,
              onSelect: $options.onSelectedFiles
            }, {
              header: _withCtx(({ chooseCallback,clearCallback }) => [
                _createVNode(_component_PrimevueSelect, {
                  id: "select-att-type",
                  modelValue: this.selectedAttType,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.selectedAttType) = $event)),
                  options: $data.store.attTypes,
                  optionLabel: "name",
                  placeholder: "Pridaj prílohu výberom jej typu",
                  class: "w-10",
                  onChange: ($event: any) => (chooseCallback())
                }, {
                  value: _withCtx((slotProps) => [
                    (slotProps.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createElementVNode("div", null, _toDisplayString(slotProps.value.name), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(slotProps.placeholder), 1))
                  ]),
                  option: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", null, _toDisplayString(slotProps.option.name), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["modelValue", "options", "onChange"]),
                _createElementVNode("div", {
                  ref: "messageDiv",
                  "on:afterMessageSend": ($event: any) => (clearCallback())
                }, null, 40, _hoisted_8)
              ]),
              content: _withCtx(({ files, removeFileCallback }) => [
                (files.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files, (file, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: file.name + file.type + file.size,
                            class: "shadow-2 p-1 flex surface-card w-10rem"
                          }, [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("div", _hoisted_12, _toDisplayString(this.attTypes[index].name), 1),
                              _createElementVNode("div", _hoisted_13, _toDisplayString(file.name), 1),
                              _createElementVNode("div", _hoisted_14, _toDisplayString($options.formattedFileSize(file.size)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                              _createVNode(_component_PrimevueButton, {
                                class: "file-danger",
                                icon: "pi pi-times",
                                onClick: ($event: any) => ($options.onRemoveTemplatingFile(file, removeFileCallback, index)),
                                severity: "danger"
                              }, null, 8, ["onClick"])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["onSelect"])
          ])
        ])
      ], 32),
      _createElementVNode("div", _hoisted_16, [
        _withDirectives(_createVNode(_component_PrimevueButton, {
          onClick: $options.sendMessage,
          label: "Odoslať",
          iconPos: "left",
          icon: "pi pi-send",
          size: "large",
          style: {"padding":"0.75rem 1.5rem"}
        }, null, 8, ["onClick"]), [
          [
            _directive_tooltip,
            { value: 'Zaslanie správy' },
            void 0,
            { top: true }
          ]
        ])
      ])
    ]),
    _: 1
  }))
}